import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useSettingsContext } from '../../components/settings/SettingsContext';
import useResponsive from '../../hooks/useResponsive';
import NavVertical from '../../components/SiteLayout/nav/NavVertical';
import NavMini from '../../components/SiteLayout/nav/NavMini';
import NavHorizontal from '../../components/SiteLayout/nav/NavHorizontal';
import Header from '../../components/SiteLayout/header';
import Main from '../../components/SiteLayout/Main';

function SiteLayout({ main }: { main: React.ReactNode }) {
  const { themeLayout } = useSettingsContext();
  const isDesktop = useResponsive('up', 'lg');
  const [open, setOpen] = useState(false);
  const isNavHorizontal = themeLayout === 'horizontal';
  const isNavMini = themeLayout === 'mini';
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  let navigation = <NavVertical openNav={open} onCloseNav={handleClose} />;
  if (isDesktop && isNavHorizontal) navigation = <NavHorizontal />;
  if (isDesktop && isNavMini) navigation = <NavMini />;

  // RITA-1545: Main bleibt unter demselben Elternteil an derselben Stelle. Ein Wechsel
  // des Baums würde die Seite mitsamt ungespeicherten Eingaben und Bearbeitungssperre beenden.
  return (
    <>
      <Header onOpenNav={handleOpen} />
      <Box
        sx={{
          display: isNavHorizontal ? 'block' : { lg: 'flex' },
          ...(!isNavHorizontal && { minHeight: { lg: 1 } }),
        }}
      >
        {navigation}
        <Main>{main}</Main>
      </Box>
    </>
  );
}

export default SiteLayout;
